import script from "./ProjectCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectCard.vue?vue&type=style&index=0&id=1d9cee4a&lang=scss"

const __exports__ = script;

export default __exports__